// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let AreasCriteria = require("./AreasCriteria.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalNeedAreas_rentalNeedV5_graphql = require("../../__generated__/RentalNeedAreas_rentalNeedV5_graphql.bs.js");

let convertFragment = RentalNeedAreas_rentalNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalNeedAreas_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalNeedAreas_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalNeedAreas_rentalNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalNeedAreas_rentalNeedV5_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalNeedAreas(props) {
  let rentalNeed = RescriptRelay_Fragment.useFragment(RentalNeedAreas_rentalNeedV5_graphql.node, convertFragment, props.rentalNeed);
  let areas = Stdlib_Array.filterMap(rentalNeed.areas.edges, x => x).map(param => param.node);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "rental need areas",
    children: JsxRuntime.jsx(AreasCriteria.make, {
      areas: areas.map(a => a.fragmentRefs)
    })
  });
}

let make = RentalNeedAreas;

exports.Fragment = Fragment;
exports.make = make;
/* AreasCriteria Not a pure module */
